import React, {useEffect, useMemo, useState} from "react";
import {ColumnsType} from "antd/lib/table";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {Col, Row, Table} from "antd";
import {TableRowSelection} from "antd/es/table/interface";
import {columnsFactory} from "./agent.data.invoices.new.merged-invoices-table.columns";
import {mergedInvoiceService} from "../../../../../../services/documents/invoices/merged.invoices.service";
import {MergedInvoice} from "../../../../../../models/documents/invoices/merged-invoice/merged.invoice";

interface AgentDataInvoicesNewInvoicesTableProps {
    accountId: number;
    onChange?: (value: number | number[] | undefined) => void;
    value?: number | number[]
    multiple: boolean;
}

export const AgentDataInvoicesNewMergedInvoicesTable: React.FC<AgentDataInvoicesNewInvoicesTableProps> = ({accountId, onChange, value, multiple}) => {

    const t = useTranslate();

    const [documents, setDocuments] = useState<MergedInvoice[]>([]);

    const columns: ColumnsType<MergedInvoice> = useMemo(() => columnsFactory(t), [t])

    const [loading, setLoading] = useState<boolean>(false);

    const rowSelection: TableRowSelection<MergedInvoice> = {
        type: multiple ? "checkbox" : "radio",
        selectedRowKeys: value ? (multiple ? (value as number[]) : [value as number]) : [],
        onChange: (selectedRowKeys: React.Key[], selectedRows: MergedInvoice[]) => {
            if (onChange) {
                if (multiple) {
                    onChange(selectedRowKeys as number[] | undefined);
                } else {
                    onChange(selectedRowKeys[0] as number | undefined);
                }
            }
        }
    }

    useEffect(() => {
        setLoading(true);
        mergedInvoiceService.getAllOpenedInvoices(accountId).then(documents => {
            setDocuments(documents);
            setLoading(false);
        });
    }, [accountId])

    return (
        <Row>
            <Col span={12}>
                <Table
                    loading={loading}
                    columns={columns}
                    dataSource={documents}
                    pagination={false}
                    rowKey={"id"}
                    rowSelection={rowSelection}
                />
            </Col>
        </Row>
    );
}